var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "hero-donate",
      class: { "hero-donate--is-recurring": _vm.isRecurring },
    },
    [
      _c("div", { staticClass: "hero-donate__title-container" }, [
        _c("h2", { staticClass: "hero-donate__title" }, [
          _vm._v(_vm._s(_vm.title)),
        ]),
      ]),
      _vm._v(" "),
      _vm.isRecurring
        ? _c("div", { staticClass: "hero-donate__subtitle-container" }, [
            _c("h3", { staticClass: "hero-donate__subtitle" }, [
              _vm._v("Kuukausittainen tukisumma"),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "donate-block__prices" },
        [
          _vm._l(_vm.currentPrices, function (item) {
            return _c(
              "span",
              { staticClass: "donate-block__price-container" },
              [
                _c(
                  "button",
                  {
                    staticClass: "donate-block__price",
                    class: {
                      "donate-block__price--active":
                        _vm.currentPrice === item.price,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.setPrice(item.price)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(item.price) +
                        " €" +
                        _vm._s(_vm.isRecurring ? "/kk" : "") +
                        "\n            "
                    ),
                  ]
                ),
                _vm._v(" "),
                item.most_popular
                  ? _c("div", { staticClass: "donate-block__most-popular" }, [
                      _vm._v("\n                Suosituin summa\n            "),
                    ])
                  : _vm._e(),
              ]
            )
          }),
          _vm._v(" "),
          _c("div", { staticClass: "donate-block__price-custom" }, [
            _c(
              "label",
              {
                staticClass: "donate-block__price-custom-text",
                attrs: { for: "wwffi-custom-price" },
              },
              [
                _vm._v(
                  "Muu summa " + _vm._s(_vm.isRecurring ? "/ kk" : "") + ":"
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "donate-block__price-custom-input-wrapper" },
              [
                !_vm.customPriceFocus
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "donate-block__price-custom-input-placeholder",
                      },
                      [
                        _vm._v(
                          "\n                    Alk. " +
                            _vm._s(_vm.minPrice) +
                            " €\n                "
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "imask",
                      rawName: "v-imask",
                      value: _vm.mask,
                      expression: "mask",
                    },
                  ],
                  ref: "customPrice",
                  attrs: { id: "wwffi-custom-price", inputmode: "numeric" },
                  on: {
                    input: _vm.setCustomPrice,
                    focus: function ($event) {
                      return _vm.setCustomPriceFocus(true)
                    },
                    blur: function ($event) {
                      return _vm.setCustomPriceFocus(false)
                    },
                  },
                }),
              ]
            ),
          ]),
        ],
        2
      ),
      _vm._v(" "),
      _c("div", { staticClass: "donate-block__submit" }, [
        _c(
          "form",
          {
            attrs: { method: "post", action: "/lahjoitus/" },
            on: { submit: _vm.submit },
          },
          [
            _c("input", {
              attrs: { name: "quantity", value: "1", type: "text", hidden: "" },
            }),
            _vm._v(" "),
            _c("input", {
              attrs: {
                name: "wwffi_donation_amount",
                type: "text",
                hidden: "",
              },
              domProps: { value: _vm.currentPrice },
            }),
            _vm._v(" "),
            _c("input", {
              attrs: { name: "wwffi_campaign", type: "text", hidden: "" },
              domProps: { value: _vm.campaign },
            }),
            _vm._v(" "),
            _c("input", {
              attrs: { name: "wwffi_preselect_gift", type: "text", hidden: "" },
              domProps: { value: _vm.preselectGiftInt },
            }),
            _vm._v(" "),
            _c("input", {
              attrs: { name: "add-to-cart", type: "text", hidden: "" },
              domProps: { value: _vm.productId },
            }),
            _vm._v(" "),
            _c("div", [
              _c(
                "button",
                {
                  staticClass: "donate-block__submit-button",
                  attrs: { disabled: !_vm.currentPrice },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.getButtonText()) +
                      "\n                "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _vm.error
              ? _c("div", { staticClass: "donate-block__submit-error" }, [
                  _vm._v(
                    "\n                " + _vm._s(_vm.error) + "\n            "
                  ),
                ])
              : _vm._e(),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }